export default "__VITE_ASSET__Cc0RmyuW__"